"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconMaximizeNew = function IconMaximizeNew(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconMaximizeNew', className),
    style: style,
    viewBox: "0 0 28 28"
  }, _react.default.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M16.8 12.6c.371 0 .727-.148.99-.41l7.41-7.41V7c0 .773.627 1.4 1.4 1.4.773 0 1.4-.627 1.4-1.4V1.4c0-.773-.627-1.4-1.4-1.4H21c-.773 0-1.4.627-1.4 1.4 0 .773.627 1.4 1.4 1.4h2.22l-7.41 7.41c-.4.4-.52 1.003-.303 1.526.216.523.727.864 1.293.864zM23.22 25.2H21c-.773 0-1.4.627-1.4 1.4 0 .773.627 1.4 1.4 1.4h5.6c.773 0 1.4-.627 1.4-1.4V21c0-.773-.627-1.4-1.4-1.4-.773 0-1.4.627-1.4 1.4v2.22l-7.41-7.41c-.55-.53-1.423-.523-1.963.017s-.547 1.413-.017 1.963l7.41 7.41zM1.4 28H7c.773 0 1.4-.627 1.4-1.4 0-.773-.627-1.4-1.4-1.4H4.78l7.41-7.41c.53-.55.523-1.423-.017-1.963s-1.413-.547-1.963-.017L2.8 23.22V21c0-.773-.627-1.4-1.4-1.4-.773 0-1.4.627-1.4 1.4v5.6c0 .566.342 1.076.865 1.292.17.071.351.108.535.108zM1.4 8.4c.773 0 1.4-.627 1.4-1.4V4.78l7.41 7.41c.55.53 1.423.523 1.963-.017s.547-1.413.017-1.963L4.78 2.8H7c.773 0 1.4-.627 1.4-1.4C8.4.627 7.773 0 7 0H1.4C.627 0 0 .627 0 1.4V7c0 .773.627 1.4 1.4 1.4z"
  })));
};

var _default = IconMaximizeNew;
exports.default = _default;